import { logger } from '../console';

type StorageValue = string | number | object | boolean | null;

const LocalStorageUtils = {
  set(key: string, value: StorageValue): boolean {
    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
      return true;
    } catch (error) {
      logger.error('Error saving to localStorage:', error);
      return false;
    }
  },

  get<T>(key: string, defaultValue: T | null = null): T | null {
    try {
      const item = localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : defaultValue;
    } catch (error) {
      logger.error('Error retrieving from localStorage:', error);
      return defaultValue;
    }
  },

  remove(key: string): boolean {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      logger.error('Error removing from localStorage:', error);
      return false;
    }
  },

  clear(): boolean {
    try {
      localStorage.clear();
      return true;
    } catch (error) {
      logger.error('Error clearing localStorage:', error);
      return false;
    }
  },

  has(key: string): boolean {
    return localStorage.getItem(key) !== null;
  },

  getAllKeys(): string[] {
    return Object.keys(localStorage);
  },

  getSize(): number {
    let total = 0;
    Object.keys(localStorage).forEach((key: string) => {
      if (Object.hasOwn(localStorage, key)) {
        total += localStorage[key].length + key.length;
      }
    });
    return total;
  },
};

export default LocalStorageUtils;
